import ImagesDev from "./images";


function isEven(number) {
    return number % 2 === 0;
}


const LifeInTheSpirit_images = () => {
    const array = Array.from({ length: 10 }, (_, i) => i + 1);
    const data = array.map((value, i) => {
        return {
            id: value + "lits",
            url: isEven(value)? ImagesDev.litsImg : ImagesDev.ministers.minTSO,
            title: "Life in the Spirit",
            description: "Life in the Spirit",
            date: "February 28, 2025"
        }
    })
    return data;
};

const HowToReadTheBible_images = () => {
    const array = Array.from({ length: 10 }, (_, i) => i + 1);
    const data = array.map((value, i) => {
        return {
            id: value + "htrtb",
            url: isEven(value)? ImagesDev.BSImg : ImagesDev.ministers.minTSO,
            title: "Life in the Spirit",
            description: "Life in the Spirit",
            date: "February 28, 2025"
        }
    })
    return data;
};

const TheHealingParty_Ghana_images = () => {
    const array = Array.from({ length: 10 }, (_, i) => i + 1);
    const data = array.map((value, i) => {
        return {
            id: value + "thpg",
            url: isEven(value)? ImagesDev.hpGImg : ImagesDev.ministers.minTSO,
            title: "Life in the Spirit",
            description: "Life in the Spirit",
            date: "February 28, 2025"
        }
    })
    return data;
};


const TheHealingParty_Ibadan_images = () => {
    const array = Array.from({ length: 10 }, (_, i) => i + 1);
    const data = array.map((value, i) => {
        return {
            id: value + "thpi",
            url: isEven(value)? ImagesDev.thpImg : ImagesDev.ministers.minTSO,
            title: "Life in the Spirit",
            description: "Life in the Spirit",
            date: "February 28, 2025"
        }
    })
    return data;
};

const EventGallery = [
    {
        id: 1,
        category: 'conferences',
        url: ImagesDev.litsImg,
        title: 'Life in the Spirit',
        name: 'Life in the Spirit',
        date: "February 28, 2025",
        location: "3c, Olaide Benson Close, Maryland, Lagos.",
        images: LifeInTheSpirit_images(),
    },
    {
        id: 2,
        category: 'conferences',
        url: ImagesDev.BSImg,
        title: "How To Read The Bible",
        name: "How To Read The Bible",
        date: "October 26, 2024",
        location: "NECA House, Hakeem Balogun Street, Alausa, Ikeja.",
        images: HowToReadTheBible_images(),
    },
    {
        id: 3,
        category: 'outreach',
        url: ImagesDev.hpGImg,
        title: "The Healing Party - Ghana",
        name: "The Healing Party - Ghana",
        date: "November 30, 2024",
        location: "Shekinah Avenue Auditorium, Accra.",
        images: TheHealingParty_Ghana_images(),
    },
    {
        id: 4,
        category: 'outreach',
        url: ImagesDev.thpImg,
        title: "The Healing Party - Ibadan",
        name: "The Healing Party - Ibadan",
        date: "November 30, 2024",
        location: "Christ The Dayspring Church, Ibadan.",
        images: TheHealingParty_Ibadan_images(),
    },
    // Add more images as needed
];

const EventGallery_ = [
    {
        id: 1,
        category: 'conferences',
        url: ImagesDev.litsImg,
        title: 'Life in the Spirit',
        date: "February 28, 2025",
        location: "3c, Olaide Benson Close, Maryland, Lagos.",
        name: "Healing Party 2024",
        images: [
            {
                id: 1,
                url: ImagesDev.litsImg,
                title: "Morning Session",
                description: "The morning session of our healing party event",
                date: "2024-03-15"
            },
            {
                id: 2,
                url: ImagesDev.hpGImg,
                title: "Morning Session",
                description: "The morning session of our healing party event",
                date: "2024-03-15"
            },
            {
                id: 2,
                url: ImagesDev.hpGImg,
                title: "Morning Session",
                description: "The morning session of our healing party event",
                date: "2024-03-15"
            },
            {
                id: 2,
                url: ImagesDev.hpGImg,
                title: "Morning Session",
                description: "The morning session of our healing party event",
                date: "2024-03-15"
            },
            {
                id: 2,
                url: ImagesDev.hpGImg,
                title: "Morning Session",
                description: "The morning session of our healing party event",
                date: "2024-03-15"
            },
            // Add more images
        ]
    },
    // Add more events
];


export default EventGallery;